import React from "react";
import SolanaLanding from "../Components/Landing/SolanaLanding";

const Solana = () => (
  <div className="flex flex-col">
    <SolanaLanding />
  </div>
);

export default Solana;
